import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import Inicio from '../components/inicio/inicio'
import Penhora from '../penhora.jsx'
import Prisao from '../prisao.jsx'
import Justificativa from '../justificativa.jsx'

export default class Router extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Inicio} />
        <Route exact path="/prisao" component={Prisao} />
        <Route exact path="/penhora" component={Penhora} />
        <Route exact path="/justificativa" component={Justificativa} />
      </Switch>
    )
  }
};


// WEBPACK FOOTER //
// ./src/config/router.js